import React from 'react';
import { StatusTag } from 'components';
import { getDossierStatusColor } from 'utils/dossierUtils';
import { DossierStatus, DossierStatusKeys } from 'types/Dossier';
import { t } from 'i18next';
import clsx from 'clsx';

export default function DossierStatusTag({
  full,
  status,
  className = '',
}: {
  status?: DossierStatus;
  full?: boolean;
  className?: string;
}) {
  if (status === undefined) {
    return null;
  }
  const statusValue = t(`statuts_dossier:${DossierStatusKeys[status]}`);
  return (
    <StatusTag
      full={full}
      status={statusValue}
      color={getDossierStatusColor(status)}
      className={clsx('!py-1 -my-1 !px-3 align-middle', className)}
    />
  );
}
